/**
 * Resource file for all public facing string constants in the app
 */
 const fr_fr = {
  LOCALE_KEY: 'French',

  LOCALE_NAME: 'French',

  MISSING_TRANSLATION: 'French',

  MAPPING_ERROR_BANNER_WARNING: 'French',

  MAPPING_ERROR_BANNER_HERE: 'French',

  PRODUCT_MAPPING_PAGE_INFO: 'French',

  VALIDATION_CONFIGURATION_PAGE_INFO: 'French',

// SystemAdminPage.tsx
  SYSTEM_ADMIN_PAGE_TITLE: 'French',

  SAVE_CONFIG_ACTION_ERROR: 'French',

  SAVE_CONFIG_SUCCESS_MSG: 'French',

  GET_CONFIG_FETCH_ERROR: (resort: string) => 'French',

  FEATURE_TOGGLES: 'French',

  DIRECT_TO_WINDOW_LABEL: 'French',

  IS_UAT_LABEL:  'French',

  IS_UAT_INFO: 'French',

  ALL_RESORTS_HOTLIST_LABEL: 'French',

  ALL_RESORTS_HOTLIST_INFO: 'French',

  RESORT_SPECIFIC_HOTLIST_LABEL: 'French',

  RESORT_SPECIFIC_HOTLIST_INFO: 'French',

  ADD_TO_HOTLIST_LABEL: 'French',

  ADD_TO_HOTLIST_INFO: 'French',

  REMOVE_FROM_HOTLIST_LABEL: 'French',

  REMOVE_FROM_HOTLIST_INFO: 'French',

  REDEMPTION_WARNING_LABEL: 'French',

  REDEMPTION_WARNING_INFO: 'French',

  GROUP_PRINT_LABEL: 'French',

  GROUP_IMPORT_LABEL: 'French',

  SHOW_CAMERA_MIRRORING_LABEL: 'French',

  SHOW_CAMERA_MIRRORING_INFO: 'French',

  VALIDATION_CONFIGURATION_LABEL: 'French',

  VALIDATION_CONFIGURATION_INFO: 'French',

  MAPPING_ERROR_BANNER_LABEL: 'French',

  MAPPING_ERROR_BANNER_INFO: 'French',

  WEEKLY_VISITOR_REPORT_LIMIT_LABEL: '/* TODO */Weekly Visitor Report Limit',
  WEEKLY_VISITOR_REPORT_LIMIT_INFO: '/* TODO */ The number of reports that can be retrieved',
  
// User Management

  USER_MANAGEMENT_PAGE_TITLE: 'French',

  USER_MANAGEMENT_PAGE_INFO: 'French',

  BLOCK_USER_ACTION_ERROR: 'French',

  GET_USERS_ACTION_ERROR: 'French',

  UNBLOCK_USER_ACTION_ERROR: 'French',

  USER_FIELD_REQUIRED_VALIDATION: 'French',

  USER_FIELD_INVALID_CHARACTERS: (invalidChars: string) => `French: \n${invalidChars}`,

  USER_NAME_NOT_AVAILABLE: 'French',

  USER_NAME_FORMAT_VALIDATION: 'French',

  USER_EMAIL_FORMAT_VALIDATION: 'French',

  USER_EMAIL_NOT_AVAILABLE: 'French',

  USER_PASSWORD_FORMAT_VALIDATION: 'French',

  USER_MANAGEMENT_FAILED_USERNAMES_ERROR: (failedUsernames: string) => 'French',

  USER_MANAGEMENT_FILTER_ERROR: (query: string) => 'French',

  USER_MANAGEMENT_USERS_PER_PAGE: 'French',

  USER_MANAGEMENT_NO_USERS: 'French',

  USER_MANAGEMENT_ACCOUNT_DISABLED: 'French',

  USER_MANAGEMENT_FETCH_USERS_FAILED: 'French',

  USER_MANAGEMENT_REMOVE_USER_TITLE: 'French',

  USER_MANAGEMENT_REMOVE_USER_MSG: (userToDelete: string) => 'French',

  USER_MANAGEMENT_REMOVE_BUTTON: 'French',

  USER_MANAGEMENT_CANCEL_REMOVE_BUTTON: 'French',

  USER_MANAGEMENT_TABLE_FIRST_NAME: 'French',

  USER_MANAGEMENT_TABLE_LAST_NAME: 'French',

  USER_MANAGEMENT_TABLE_USERNAME: 'French',

  USER_MANAGEMENT_TABLE_EMAIL: 'French',

  USER_MANAGEMENT_TABLE_ROLE: 'French',

  USER_MANAGEMENT_TABLE_RESORTS: 'French',

  USER_MANAGEMENT_TABLE_PASSWORD: 'French',

  USER_MANAGEMENT_TABLE_LAST_LOGIN: 'French',

  USER_MANAGEMENT_TABLE_NO_USERS: 'French',

  USER_ROW_SELECT_PLACEHOLDER: 'French',

  USER_ROW_CREATE_USER: 'French',

  USER_ROW_SAVE_CHANGES: 'French',

  USER_ROW_DISCARD_CHANGES: 'French',

  USER_ROW_UPDATE_USER: 'French',

  USER_ROW_DELETE_USER: 'French',

  USER_ROW_FIRST_NAME: 'French',

  USER_ROW_LAST_NAME: 'French',

  USER_ROW_USERNAME: 'French',

  USER_ROW_SUGGESTED_USERNAME: (suggestedUsername: string) => 'French',

  USER_ROW_EMAIL: 'French',

  USER_ROW_USER_ROLE: 'French',

  USER_ROW_NO_ROLES: 'French',

  USER_ROW_PASSWORD: 'French',

  USER_ROW_UPDATE_PASSWORD: 'French',

  USER_SEARCH_BOX_BLACKLIST_WARNING: 'French',

  USER_SEARCH_BOX_TITLE: 'French',

  USER_SEARCH_BOX_SEARCH: 'French',

  USER_SEARCH_BOX_PLACEHOLDER: 'French',

  USER_EDIT_MENU_ENABLE_USER_TITLE: 'French',

  USER_EDIT_MENU_DISABLE_USER_TITLE: 'French',

  USER_EDIT_MENU_ENABLE_USER: 'French',

  USER_EDIT_MENU_DISABLE_USER: 'French',

  USER_EDIT_MENU_DELETE_USER_TITLE: 'French',

  USER_EDIT_MENU_RESET_PASSWORD: 'French',

  USER_EDIT_MENU_MORE_OPTIONS: 'French',

// Help and Training Pages
  HELP_TRAINING_PAGE_TITLE: 'French',

  HELP_TRAINING_LOADING: 'French',

  HELP_TRAINING_FETCH_FAILED: 'French',

  HELP_TRAINING_NO_DOCS: 'French',

  HELP_TRAINING_VIEWER_FAILED: 'French',

  HELP_TRAINING_BACK: 'French',

  HELP_TRAINING_UPLOAD_BUTTON: 'French',

  HELP_TRAINING_REPLACE_BUTTON: 'French',

  HELP_TRAINING_DELETE_BUTTON: 'French',

  HELP_TRAINING_FORM_TITLE_UPLOAD: 'French',

  HELP_TRAINING_FORM_TITLE_REPLACE: 'French',

  HELP_TRAINING_FORM_FILE_LABEL: 'French',

  HELP_TRAINING_FORM_DOC_TITLE_LABEL: 'French',

  HELP_TRAINING_FORM_SORT_ORDER_LABEL: 'French',

  HELP_TRAINING_FORM_SUBMIT: 'French',

  HELP_TRAINING_FORM_CANCEL: 'French',

  HELP_TRAINING_DELETE_CONFIRM_TITLE: 'French',

  HELP_TRAINING_DELETE_CONFIRM_MSG: (title: string) => `French ${title}`,

  HELP_TRAINING_WRITE_FAILED: 'French',

// FAQ Pages
  FAQ_PAGE_TITLE: 'French',

  FAQ_PAGE_FETCH_FAILED: 'French',

  FAQ_PAGE_NO_FAQ: 'French',

  FAQ_PAGE_LOADING_FAQ: 'French',

  MAKE_FAQ_PAGE_NO_FAQ: 'French',

  MAKE_FAQ_PAGE_MAKE_FAQ_JSON: 'French',

  MAKE_FAQ_PAGE_NEW_FAQ: 'French',

  MAKE_FAQ_PAGE_SAVE_FAQ: 'French',

// Release Notes Pages
  RELEASE_NOTES_PAGE_TITLE: 'French',

  RELEASE_NOTES_PAGE_LOADING: 'French',

  RELEASE_NOTES_PAGE_NO_NOTES: 'French',

  RELEASE_NOTES_PAGE_FETCH_FAILED: 'French',

  MAKE_RELEASE_NOTES_PAGE_JSON: 'French',

  MAKE_RELEASE_NOTES_NO_NOTES: 'French',

  MAKE_RELEASE_NOTES_NEW_NOTE: 'French',

  MAKE_RELEASE_NOTES_SUBMIT_NOTES: 'French',

// App Doc Form
  APP_DOC_FAQ_NEEDS_TITLE: 'French',

  APP_DOC_FAQ_NEEDS_BODY: 'French',

  APP_DOC_FAQ_ITEM_HEADER: 'French',

  APP_DOC_FORM_LABEL_TITLE: 'French',

  APP_DOC_FORM_LABEL_ROLES: 'French',

  APP_DOC_FORM_SUBLABEL_ROLES: 'French',

  APP_DOC_FORM_LABEL_DTW_RESORTS: 'French',

  APP_DOC_FORM_SAVE: 'French',

  APP_DOC_FORM_CANCEL: 'French',

// Auth
  GET_CONFIG_ACTION_ERROR : 'French',

  GET_USER_INFO_ACTION_ERROR: 'French',

  AUTH0_LOGIN_ERROR: 'French',

  AUTH0_LOGIN: 'French',

  AUTH0_LOGIN_TITLE: 'French',

  LOGIN_FORM_APP_CONFIG_FETCH_FAILED: 'French',

  LOGIN_FORM_ALL_FIELDS_REQUIRED: 'French',

  LOGIN_FORM_ENTER_USERNAME: 'French',

  LOGIN_FORM_USERNAME: 'French',

  LOGIN_FORM_ENTER_PASSWORD: 'French',

  LOGIN_FORM_PASSWORD: 'French',

  LOGIN_FORM_LOGIN_TITLE: 'French',

  LOGIN_FORM_LOGIN: 'French',

// Branding
  RESORT_TOOLS_LOGO_HEADER: 'French',

// copyToClipboard
  COPIED_TO_CLIPBOARD: 'French',

  COPY_TO_CLIPBOARD: 'French',

// core
  GET_APPLIANCE_VERSION_ACTION_ERROR: 'French',

// entitlementTypes
  GET_ENTITLEMENT_TYPES_ACTION_ERROR: 'French',

// entitlementTypesMetadata
  GET_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR: 'French',

  UPDATE_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR:  'French',

// forms
  AUTO_FORM_SAVE: 'French',

  AUTO_FORM_RESET: 'French',

  DROPDOWN_PLEASE_SELECT: 'French',

  CHARACTER_COUNT_CHARACTERS: 'French',

  PASSWORD_FIELD_SHOW_PASSWORD: 'French',

  PASSWORD_FIELD_HIDE_PASSWORD: 'French',

  TOGGLE_SWITCH_ON: 'French',

  TOGGLE_SWITCH_OFF: 'French',

// Landing page
  RESET_USER_PASSWORD_MISMATCH_ERROR: 'French',

  RESET_USER_PASSWORD_RESET_COMPLETE: 'French',

  RESET_USER_PASSWORD_CANCEL: 'French',

  RESET_USER_PASSWORD_OK: 'French',

  RESET_USER_PASSWORD_PASSWORD_RESET: 'French',

  RESET_USER_PASSWORD_RESET_INSTRUCTIONS: 'French',

  RESET_USER_PASSWORD_PASSWORD_PLACEHOLDER: 'French',

  RESET_USER_PASSWORD_CONNECTION_ERROR: 'French',

  RESET_USER_PASSWORD_SAVE: 'French',

// layout
  FLOATING_MENU_CLOSE: 'French',

  FLOATING_MENU_OPEN: 'French',

  MODAL_TITLE_HEADER_CLOSE: 'French',

// pageHeader
  HEADER_MENU_SYSTEM_ADMIN: 'French',

  HEADER_MENU_VALIDATION_CONFIG: 'French',

  HEADER_MENU_USER_MANAGEMENT: 'French',

  HEADER_MENU_HELP_AND_TRAINING: 'French',

  HEADER_MENU_FAQ: 'French',

  HEADER_MENU_REPORTS: 'French',

  HEADER_MENU_RELEASE_NOTES: 'French',

  HEADER_MENU_SIGNOUT: 'French',

  HEADER_MENU_PRODUCT_MAPPING: 'French',

  PAGE_HEADER_BACK_TO_LANDING: 'French',

  PAGE_HEADER_SIGNED_IN_AS: (currentUser: string) => 'French',

  PAGE_HEADER_SIGNED_IN_AS_WITH_ROLE: (currentUser: string, userRole: string) => 'French',

  RESORT_SELECT_MENU_LOAD_CONFIG_ERROR: (resortName: string) => 'French',

// resortDetails
  GET_RESORT_DETAILS_ACTION_ERROR: 'French',

// validationConfigurationTool
  VALIDATION_CONFIG_INVALID_EFFECTIVE_DATE: 'French',

  VALIDATION_CONFIG_INVALID_EXPIRATION_DATE: 'French',

  VALIDATION_CONFIG_EXPIRES_BEFORE_EFFECTIVE_DATE: 'French',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'French',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'French',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'French',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'French',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_SEASON_START: 'French',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_SEASON_END: 'French',

  VALIDATION_CONFIG_FAILED_NETWORK_REQUEST: 'French',

  VALIDATION_CONFIG_UNABLE_TO_SAVE: 'French',

  VALIDATION_CONFIG_ERROR_OVERLAPPING_DATES: 'French',

  VALIDATION_CONFIG_CANCEL_EDITS: 'French',

  VALIDATION_CONFIG_EDIT_PRODUCTS: 'French',

  VALIDATION_CONFIG_SAVE_PRODUCTS: 'French',

  VALIDATION_CONFIG_SAVE: 'French',

  VALIDATION_CONFIG_CANCEL: 'French',

  VALIDATION_CONFIG_SAVE_PRODUCTS_CONFIRMATION: 'French',

  VALIDATION_CONFIG_DATA_CHANGE_WARNING : 'French',

  VALIDATION_CONFIG_START_DATE_PLACEHOLDER: 'French',

  VALIDATION_CONFIG_EXPIRE_DATE_PLACEHOLDER: 'French',

  VALIDATION_CONFIG_NO_DATA: 'French',

  VALIDATION_CONFIG_TABLE_PRODUCT: 'French Product',

  VALIDATION_CONFIG_TABLE_SEASON: 'French Season',

  VALIDATION_CONFIG_TABLE_FULFILLMENT_SEASON: 'French Fulfillment Season',

  VALIDATION_CONFIG_TABLE_MAX_DAYS: 'French Max Days',

  VALIDATION_CONFIG_TABLE_START_DATE: 'French Start Date',

  VALIDATION_CONFIG_TABLE_EXPIRE_DATE: 'French End Date',

  VALIDATION_CONFIG_TITLE: 'French',

  VALIDATION_CONFIG_ROW_UNLIMITED: 'French',

  VALIDATION_CONFIG_ROW_MAX_DAYS: (maxDays: number) => `${maxDays} French`,

  VALIDATION_CONFIG_ROW_START_DATE: 'French',

  VALIDATION_CONFIG_ROW_EXPIRE_DATE: 'French',


// version
  CENTRAL_APPLIANCE_VERSION: 'French',

  RESORT_TOOLS_VERSION: 'French',

// webcam
  PHOTO_BOOTH_CAM: 'French',

  PHOTO_BOOTH_SELECT_WEBCAM: 'French',

  PHOTO_BOOTH_SELECT_WEBCAM_PLACEHOLDER: 'French',

  PHOTO_BOOTH_FLIP_CAMERA_FRAME_HORIZONTALLY: 'French',

  PHOTO_BOOTH_FLIP_CAMERA_IMAGE_HORIZONTALLY: 'French',

  PHOTO_BOOTH_CANCEL_RETAKE: 'French',

  PHOTO_BOOTH_TAKE_NEW_PICTURE: 'French',

  PHOTO_BOOTH_TAKE_PICTURE: 'French',

  PHOTO_BOOTH_SAVE_PICTURE: 'French',

  PHOTO_BOOTH_SAVE: 'French',

  PHOTO_BOOTH_RETAKE: 'French',

  PHOTO_BOOTH_CAPTURE: 'French',

  PHOTO_BOOTH_CANCEL: 'French',

  PHOTO_BOOTH_REVERSE_CAMERA: 'French',

  WEBCAM_BROWSER_ERROR: 'French',

  WEBCAM_STREAMING_ERROR: 'French',

// resortMappingTool
  GET_RESORT_MAPPING_ACTION_ERROR: 'French',

  GET_RESORT_MAPPING_HAS_ERROR_ACTION_ERROR: 'French',

  UPDATE_MAPPING_ERRORS_ACTION_ERROR: 'French',

  PRODUCT_MAPPING_UPLOAD_TITLE: 'French',

  PRODUCT_MAPPING_UPLOAD_CANCEL: 'French',

  PRODUCT_MAPPING_UPLOAD_UPLOAD: 'French',

  PRODUCT_MAPPING_UPLOAD_DOWNLOAD: 'French',

  PRODUCT_MAPPING_UPLOAD_ONE: 'French',

  PRODUCT_MAPPING_UPLOAD_ONE_WARNING: 'French',

  PRODUCT_MAPPING_UPLOAD_TWO: 'French',

  PRODUCT_MAPPING_UPLOAD_TWO_WARNING: 'French',

  PRODUCT_MAPPING_UPLOAD_THREE: 'French',

  PRODUCT_MAPPING_UPLOAD_FOUR: 'French',

  PRODUCT_MAPPING_UPLOAD_CHOOSE_FILE: 'French',

  PRODUCT_MAPPING_UPLOAD_INSTRUCTION: 'French',

  PRODUCT_MAPPING_UPLOAD_SUCCESS: 'French',

  PRODUCT_MAPPING_UPLOAD_WRONG_HEADERS: 'French',

  PRODUCT_MAPPING_UPLOAD_NO_MATCH: "No entitlement id matches found",

  PRODUCT_MAPPING_UPLOAD_NO_CHANGES: 'French',

  PRODUCT_MAPPING_UPLOAD_NO_FILE: 'French',

  PRODUCT_MAPPING_UPLOAD_WRONG_FILE_TYPE: 'French',

  RESORT_MAPPING_COLUMN_PRODUCT: 'French',

  RESORT_MAPPING_COLUMN_SEASON: 'French',

  RESORT_MAPPING_COLUMN_AGE: 'French',

  RESORT_MAPPING_COLUMN_FULFILLMENT_SEASON: 'French',

  RESORT_MAPPING_COLUMN_PRODUCT_HEADER_CODE: 'French',

  RESORT_MAPPING_COLUMN_ACCESS_RULE: 'French',

  RESORT_MAPPING_COLUMN_MEDIA_PRODUCT_HEADER_CODE: 'French',

  RESORT_MAPPING_COLUMN_DEPARTMENT: 'French',

  RESORT_MAPPING_COLUMN_CATEGORY: 'French',

  RESORT_MAPPING_COLUMN_ITEM: 'French',

  RESORT_MAPPING_COLUMN_PRODUCT_TYPE: 'French',

  RESORT_MAPPING_COLUMN_WTP_RELOAD: 'French',

  RESORT_MAPPING_COLUMN_MAPPING_STATUS: 'French',

  PRODUCT_MAPPING_PAGE_LOAD_ERROR: 'French',

  PRODUCT_MAPPING_PAGE_EDIT_PRODUCTS: 'French',

  PRODUCT_MAPPING_PAGE_SAVE_PRODUCTS: 'French',

  PRODUCT_MAPPING_PAGE_SYNC: 'French',

  PRODUCT_MAPPING_PAGE_DOWNLOAD: 'French',

  PRODUCT_MAPPING_PAGE_BULK_UPLOAD: 'French',

  PRODUCT_MAPPING_PAGE_TITLE: 'French',

  PRODUCT_MAPPING_PAGE_NOT_IMPLEMENTED: 'French',

//guest media

  ASSOC_RFID_REPRINT_MESSAGE_NO_ID: 'French',

  ASSOC_RFID_REPRINT_MESSAGE_HAS_ID: (currentRfid: string | undefined) => 'French',

  ASSOC_RFID_MODAL_HEADER: 'French',

  GUEST_LINK_RFID_LABEL: 'French',

  GUEST_LINK_RFID_INPUT_TITLE: 'French',

  GUEST_LINK_RFID_INPUT_PLACEHOLDER: 'French',

  RFID_LENGTH_ERROR: 'French',

  RFID_DUPLICATE_ERROR: (firstName: string, lastName: string, chipId: string) => 'French',

  RFID_FORM_LABEL: 'French',

  RFID_FORM_TITLE: (guestName: string) => 'French',

  RFID_FORM_RETURN: 'French',

  RFID_FORM_CANCEL_RFID_LINKING: 'French',

  RFID_FORM_SUBMIT_RFID: 'French',

  RFID_FORM_OKAY: 'French',

  RFID_FORM_CANCEL: 'French',

  RFID_FORM_SUBMIT: 'French',

  MEDIA_HISTORY_MODAL_TITLE: 'French',

  MEDIA_HISTORY_MODAL_ACTIVE: 'French',

  MEDIA_HISTORY_MODAL_INACTIVE: 'French',

  MEDIA_STATUS_SELECTOR_DISABLED: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_ID: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_RFID: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_AGENT: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_PRINT_DATE: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_PRINT_STATUS: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_RESORT: 'French',

  MEDIA_HISTORY_MODAL_COLUMN_STATUS: 'French',

  MEDIA_HISTORY_MODAL_MESSAGE: 'French',

  MEDIA_HISTORY_MODAL_CONFIRMATION: (mediaId: string | undefined) => 'French',

  MEDIA_HISTORY_MODAL_NO_DATA: 'French',

  MEDIA_HISTORY_MODAL_FAILED_FETCH: (guestName: string) => 'French',

  MEDIA_HISTORY_MODAL_CANCEL: 'French',

  MEDIA_HISTORY_MODAL_CONFIRM: 'French',


  GROUP_PRINT_MODAL_LABEL: 'French',

  GROUP_PRINT_MODAL_GUEST_COUNT: (guestCount: number) => 'French',

  GROUP_PRINT_MODAL_WARNING: 'French',

  GROUP_PRINT_MODAL_CANCEL: 'French',

  GROUP_PRINT_MODAL_PRINT: 'French',

  GROUP_PRINT_MODAL_GENERATE_PDF: 'French',

  GROUP_PRINT_MODAL_LINK_RFID: 'French',

  GROUP_PRINT_MODAL_OKAY: 'French',

  GROUP_PRINT_MODAL_GROUP_LINK: 'French',

  GROUP_PRINT_MODAL_GROUP_PRINT: 'French',

  GROUP_PRINT_MODAL_FOUND_ERRORS: (errorCount) => 'French',

  PASS_PRINT_MODAL_NO_ACTIVE_MEDIA: 'French',

  PASS_PRINT_MODAL_GENERATE_PDF: 'French',

  PASS_PRINT_MODAL_CANCEL_TITLE: 'French',

  PASS_PRINT_MODAL_CANCEL: 'French',

  PASS_PRINT_MODAL_HEADING: 'French',

  PASS_PRINT_MODAL_OK_BTN_CLOSE: 'French',

  PASS_PRINT_MODAL_OK_BTN_PRINT: 'French',

  REISSUE_MEDIA_ACTION_UNKNOWN_ERROR: 'French',

  NEED_PHOTO_AND_WAIVER: 'French',
  NEED_PHOTO           : 'French',
  NEED_WAIVER          : 'French',

  PRINT_CONFIRMATION_1: (guestName: string) => 'French',
  PRINT_CONFIRMATION_2: 'French',

  API_ERROR: 'French',

  PRINT_FAILURE: 'French',

//guest redemption

  DTW_ENTITLEMENT_MODAL_MESSAGE: 'French',

  DTW_ENTITLEMENT_MODAL_CONFIRMATION: 'French',

  DTW_ENTITLEMENT_MODAL_CONFIRMATION_NAME: (guestName: string) => 'French ',

  DTW_ENTITLEMENT_MODAL_CANCEL: 'French',

  DTW_ENTITLEMENT_MODAL_CONFIRM: 'French',

  DTW_ENTITLEMENT_MODAL_HEADING: 'French',

  DTW_ENTITLEMENT_MODAL_GUEST_LABEL: "Guest:",

  DTW_ENTITLEMENT_MODAL_PASS_LABEL: "Pass:",

  DTW_ENTITLEMENT_MODAL_NO_ITEMS: "No Passes Available",

  DTW_ENTITLEMENT_MODAL_NO_DAYS: "No Days Available",

  DTW_ENTITLEMENT_MODAL_REDEMPTION_COMPLETE: 'French',

  DTW_ENTITLEMENT_MODAL_FAILED_FETCH: (guestName: string) => 'French',

  DTW_ENTITLEMENT_MODAL_FAILED_REDEMPTION: (guestName: string) => 'French',

  DTW_ENTITLEMENT_MODAL_PLURALIZED_DAY: (quantity: number) => 'French',

  FNF_TABLE_CONFIRMATION: 'French',

  FNF_TABLE_CONFIRMATION_NAME: (days: string, possessiveGuestName: string) => 'French',

  FNF_TABLE_ENTITLEMENT_NAME: 'French',

  FNF_TABLE_DAYS_AVAILABLE: 'French',

  FNF_TABLE_DAYS_USED: 'French',

  FNF_TABLE_REDEEM: 'French',

  FNF_TABLE_BLACKED_OUT: 'French',

  FNF_TABLE_ALL_USED: 'French',

  FNF_TABLE_NO_ENTITLEMENTS: 'French',

  FNF_TABLE_PLURALIZED_DAY: (redeemQuantity: number) => 'French',

  FNF_MODAL_REDEMPTION_COMPLETE: 'French',

  FNF_HISTORY_COLUMN_FROM_GUEST: 'French',

  FNF_HISTORY_COLUMN_TO_GUEST: 'French',

  FNF_HISTORY_COLUMN_SHARE_DATE: 'French',

  FNF_HISTORY_COLUMN_CLAIM_DATE: 'French',

  FNF_HISTORY_COLUMN_REVOKE_DATE: 'French',

  FNF_HISTORY_COLUMN_STATUS: 'French',

  FNF_HISTORY_COLUMN_DATE: 'French',

  FNF_HISTORY_COLUMN_RESORT: 'French',

  FNF_HISTORY_COLUMN_REF_ID: 'French',

  FNF_HISTORY_SHARE: 'French',

  FNF_HISTORY_REDEEM: 'French',

  FNF_HISTORY_GUEST_LABEL: 'French',

  FNF_HISTORY_NO_HISTORY: 'French',

  FNF_HISTORY_COPY_MGID: 'French',

  FNF_HISTORY_FAILED_FETCH: (guestName: string) => 'French',

  FNF_MODAL_REDEEM_TAB: 'French',

  FNF_MODAL_HISTORY_TAB: 'French',

  FNF_MODAL_FAILED_FETCH: (guestName: string) => 'French',

  FNF_MODAL_FAILED_REDEMPTION: (guestName: string) => 'French',

  VIEW_DAYS_VIEW_DAYS_TAB_HEADER: 'French',

  VIEW_DAYS_VIEW_HISTORICAL_TAB_HEADER: 'French',

  VIEW_DAYS_FAILED_FETCH_ERROR: 'French',

  VIEW_DAYS_HISTORY_ERROR: 'French',

  VIEW_DAYS_RESORT_SELECTOR_PASS_LABEL: 'French',

  VIEW_DAYS_RESORT_SELECTOR_PASS_TITLE: 'French',

  VIEW_DAYS_RESORT_SELECTOR_RESORT_LABEL: 'French',

  VIEW_DAYS_RESORT_SELECTOR_RESORT_TITLE: 'French',

  VIEW_DAYS_TAB_NOT_APPLICABLE: 'French',

  VIEW_DAYS_TAB_COLUMN_REDEMPTION_ID: 'French',

  VIEW_DAYS_TAB_COLUMN_TYPE: 'French',

  VIEW_DAYS_TAB_COLUMN_DATE: 'French',

  VIEW_DAYS_TAB_COLUMN_RESORT: 'French',

  VIEW_DAYS_TAB_COLUMN_MODIFIED_BY: 'French',

  VIEW_DAYS_TAB_COLUMN_DAYS_USED: 'French',

  VIEW_DAYS_TAB_COLUMN_NOTES: 'French',

  VIEW_DAYS_TAB_MODAL_HEADER: 'French',

  VIEW_DAYS_CORRECTION_BUTTON_TITLE: 'French',

  VIEW_DAYS_STATS_TOTAL_DAYS: 'French',

  VIEW_DAYS_STATS_RESORTS: 'French',

  VIEW_DAYS_STATS_MOST_VISITED: (name: string) => 'French',

  VIEW_DAYS_GUEST_LABEL: 'French',

  VIEW_DAYS_FAILED_FETCH: (guestName: string) => 'French',

  VIEW_DAYS_FAILED_HISTORY: (guestName: string) => 'French',

  VIEW_DAYS_NO_DATA: 'French',

  VIEW_DAYS_NO_DATA_FOUND_ERROR: 'French',

  VIEW_DAYS_UNLIMITED: 'French',

  VIEW_HISTORICAL_TAB_LOADING_DATA: 'French',

  VIEW_HISTORICAL_TAB_TOTAL_DAYS: (totalDays: number) => 'French',

  DAY_CORRECTION_REDEMPTION_LABEL: 'French',

  DAY_CORRECTION_REDEMPTION_TITLE: 'French',

  DAY_CORRECTION_REDEMPTION_BUTTON_TITLE: 'French',

  DAY_CORRECTION_QUANTITY_LABEL: 'French',

  DAY_CORRECTION_INFO: 'French',

  DAY_CORRECTION_NOTE_LABEL: 'French',

  DAY_CORRECTION_INPUT: 'French',

  DAY_CORRECTION_INPUT_PLACEHOLDER: 'French',

  DAY_CORRECTION_BUTTON_TITLE: 'French',

  DAYS_REDEEM_NO_DAYS: 'French',

  DAYS_REDEEM_SELECT_TITLE: 'French',

  DAYS_REDEEM_REDEEM: 'French',

  DAYS_REDEEM_BUTTON: 'French',

  DAYS_REDEEM_NUMBER_DAYS: (i:number) => 'French',

  REDEMPTION_STATS_TOTAL_DAYS: 'French',

  REDEMPTION_STATS_DAYS_AVAILABLE: 'French',

  REDEMPTION_STATS_DAYS_USED: 'French',

  REDEMPTION_HISTORY_LABEL: 'French',

  REDEMPTION_HISTORY_DATE: 'French',

  REDEMPTION_HISTORY_RESORT: 'French',

  REDEMPTION_HISTORY_REF_ID: 'French',

  REDEMPTION_HISTORY_NO_HISTORY: 'French',

  REDEMPTION_ID_LABEL: 'French',

  REDEMPTION_ID_TITLE: 'French',

  REDEMPTION_ID_BUTTON_TITLE: 'French',

  REDEMPTION_ID_REFERENCE_LABEL: 'French',

  REDEMPTION_ID_REFERENCE_TITLE: 'French',

  REDEMPTION_ID_SAVE_BUTTON_TITLE: 'French',

  REDEMPTION_ID_SAVE_BUTTON: 'French',

//waivers
  WAIVER_ERROR: 'French',

  WAIVER_UNKNOWN: 'French',

  WAIVER_ALL_FIELDS_REQUIRED: 'French',

  WAIVER_ERROR_OVER_18: 'French',

  WAIVER_UNKNOWN_ERROR: 'French',

  WAIVER_GENERIC_COMMENT: 'French',

  WAIVER_MODAL_LOADING: 'French',

  WAIVER_MODAL_ERROR: 'French',

  WAIVER_MODAL_UNKNOWN_TYPE: (version: number) => 'French',

  WAIVER_MODAL_HEADING: 'French',

  WAIVER_SIGNATURE_COMPLETED_BY: 'French',

  WAIVER_SIGNATURE_FIRST_NAME_LABEL: 'French',

  WAIVER_SIGNATURE_FIRST_NAME_TITLE: 'French',

  WAIVER_SIGNATURE_FIRST_NAME_INPUT: 'French',

  WAIVER_SIGNATURE_LAST_NAME_LABEL: 'French',

  WAIVER_SIGNATURE_LAST_NAME_TITLE: 'French',

  WAIVER_SIGNATURE_LAST_NAME_INPUT: 'French',

  WAIVER_SIGNATURE_DOB_LABEL: 'French',

  WAIVER_SIGNATURE_DOB_TITLE: 'French',

  WAIVER_SIGNATURE_DOB_INPUT:  'French',

  WAIVER_SIGNATURE_CANCEL_TITLE: 'French',

  WAIVER_SIGNATURE_SUBMIT_TITLE: 'French',

  WAIVER_CANCEL: 'French',

  WAIVER_SUBMIT: 'French',

  WAIVER_TABLE_COLUMN_WAIVER: 'French',

  WAIVER_TABLE_COLUMN_WAIVER_SIGNED: 'French',

  WAIVER_TABLE_COLUMN_DATE_SIGNED: 'French',

  WAIVER_TABLE_UNKNOWN: 'French',

  WAIVER_TABLE_UNSIGNED: 'French',

  WAIVER_TABLE_EXPIRED: (expirationDate : string | undefined) => 'French',

  WAIVER_TABLE_SIGNED: 'French',

  WAIVER_TABLE_NOT_SIGNED: 'French',

  WAIVER_TABLE_NO_WAIVERS: 'French',

  WAIVER_TABLE_GUEST_LABEL: 'French',

  WAIVER_TABLE_CLICK_TO_SIGN: 'French',

//guest card

  GUEST_CARD_DEFERRED_BANNER: 'French',

  GUEST_CARD_HOTLIST_ALL_RESORTS: 'French',

  GUEST_CARD_HOTLIST_RESORT: (resortName: string) => 'French',

  GUEST_CARD_HOTLIST: 'French',

  GUEST_CARD_MEDIA_DISABLED: 'French',

  GUEST_CARD_COPIED_MASTER_GUEST_ID: 'French',

  GUEST_CARD_COPIED_MEDIA_ID: 'French',

  GUEST_CARD_FAILED_TO_LOAD: 'French',

  GUEST_CARD_OVERFLOW_TOGGLE: 'French',

  GUEST_CARD_OVERFLOW_COPY_MGID: 'French',

  GUEST_CARD_OVERFLOW_VIEW_DAYS: 'French',

  GUEST_CARD_OVERFLOW_GUEST_HAS_PASS: 'French',

  GUEST_CARD_OVERFLOW_GUEST_NO_PASS: 'French',

  GUEST_CARD_OVERFLOW_MEDIA_HISTORY: 'French',

  GUEST_CARD_OVERFLOW_MEDIA_HISTORY_TITLE: (guestName: string) => 'French',

  GUEST_CARD_OVERFLOW_PUT_HOTLIST: 'French',

  GUEST_CARD_OVERFLOW_ALREADY_HOTLISTED: 'French',

  GUEST_CARD_OVERFLOW_NO_PASS_HOTLIST: 'French',

  GUEST_CARD_OVERFLOW_HOTLIST: 'French',

  GUEST_CARD_OVERFLOW_VIEW_COMMENTS: 'French',

  GUEST_CARD_OVERFLOW_TAKE_HOTLIST: 'French',

  GUEST_CARD_OVERFLOW_REMOVE_HOTLIST: 'French',

  GUEST_CARD_OVERFLOW_COMMENT_HISTORY: (guestName: string) => 'French',

  GUEST_CARD_OVERFLOW_ADD_COMMENT: 'French',

  GUEST_CARD_OVERFLOW_ADD_COMMENT_TITLE: (guestName: string) => 'French',

  GUEST_PROFILE_YEARS_OLD: (age: number) => 'French',

  GUEST_PROFILE_NO_DOB: 'French',

  GUEST_PROFILE_TOOLTIP: 'French',

  GUEST_PROFILE_DISABLED_TOOLTIP: 'French',

  PASS_OVERVIEW_NO_MEDIA: 'French',

  PASS_OVERVIEW_TITLE: 'French',

  PASS_OVERVIEW_COPY_BUTTON: 'French',

  PASS_OVERVIEW_SEASON: 'French',

  PASS_OVERVIEW_NAME: 'French',

  PASS_OVERVIEW_NO_PASSES: 'French',

  PASS_OVERVIEW_NO_ENTITLEMENTS: 'French',

  PRIMARY_ACTIONS_PRINT_CARD: 'French',

  PRIMARY_ACTIONS_LINK_CARD: 'French',

  PRIMARY_ACTIONS_WAIVER_SIGNED: 'French',

  PRIMARY_ACTIONS_WAIVER_SIGNATURE: 'French',

  SECONDARY_ACTIONS_REDEEM_PASS: 'French',

  SECONDARY_ACTIONS_REDEEM_FNF: 'French',

  SECONDARY_ACTIONS_IMPORT_TOOLTIP: 'French',

//guest comments

  ADD_COMMENT_GUEST_LABEL: 'French',

  ADD_COMMENT_SUBJECT_LABEL: 'French',

  ADD_COMMENT_COMMENTS_LABEL: 'French',

  ADD_COMMENT_CHARACTER_INFO: (minChars: number, maxChars: number) => 'French',

  ADD_COMMENT_ADD_COMMENT: 'French',

  ADD_COMMENT_BUTTON_TITLE: (guestName: string) => 'French',

  ADD_COMMENT_ERROR: 'French',

  COMMENT_HISTORY_COLUMN_DATE: 'French',

  COMMENT_HISTORY_COLUMN_AGENT: 'French',

  COMMENT_HISTORY_COLUMN_SUBJECT: 'French',

  COMMENT_HISTORY_COLUMN_COMMENT: 'French',

  COMMENT_HISTORY_NO_HISTORY: 'French',

  COMMENT_HISTORY_FAILED_FETCH: (guestName: string) => 'French',

  COMMENT_NO_SUBJECT: 'French',

  COMMENT_NO_COMMENT: 'French',

  COMMENT_HISTORY_FETCH_ERROR: 'French',

  COMMENT_HISTORY_VIEW_COMMENTS: 'French',

//guest contact

  ADDRESS_NO_ADDRESS_TITLE: 'French',

  ADDRESS_NO_ADDRESS: 'French',

  ADDRESS_NO_DATA: 'French',

  ADDRESS_LINE_ONE: 'French',

  ADDRESS_LINE_TWO: 'French',

  ADDRESS_CITY: 'French',

  ADDRESS_NO_CITY: 'French',

  ADDRESS_STATE: 'French',

  ADDRESS_NO_STATE: 'French',

  ADDRESS_POSTAL: 'French',

  ADDRESS_NO_POSTAL: 'French',

  ADDRESS_COUNTRY: 'French',

  ADDRESS_NO_COUNTRY: 'French',

//guest photo

  GUEST_PHOTO_MODAL_HEADING: 'French',

  GUEST_PHOTO_GUEST_LABEL: 'French',

//hotlist

  HOTLIST_ADD_HOTLIST: 'French',

  HOTLIST_PUT_HOTLIST: (guestName: string) => 'French',

  HOTLIST_NO_ENTITLEMENT: 'French',

  HOTLIST_NO_RESORT: 'French',

  HOTLIST_NO_REASON: 'French',

  HOTLIST_NO_COMMENT: 'French',

  HOTLIST_INVALID_EFF_DATE: 'French',

  HOTLIST_INVALID_EXP_DATE: 'French',

  HOTLIST_PREDATED_EFF_DATE: 'French',

  HOTLIST_EXPIRES_EFF_DATE: 'French',

  HOTLIST_MODAL_NO_PASS_SELECTED: 'French',

  HOTLIST_MODAL_GUEST_LABEL: 'French',

  HOTLIST_MODAL_PASS_LABEL: 'French',

  HOTLIST_MODAL_PASS_PLACEHOLDER: 'French',

  HOTLIST_MODAL_FAILED_ENTITLEMENTS: 'French',

  HOTLIST_MODAL_RESORT_LABEL: 'French',

  HOTLIST_MODAL_REPORTER_CONTACT_NUMBER: 'French',

  HOTLIST_COMMENT_WITH_REPORTER_CONTACT: (phoneNumber: string, comment: string) => 'French',

  HOTLIST_MODAL_DIRECT_LINE: 'French',

  HOTLIST_MODAL_ENTER_PHONE_NUMBER: 'French',

  HOTLIST_MODAL_PHONE_EXTENSION: 'French',

  HOTLIST_MODAL_PHONE_NUMBER_REQUIRED: 'French',

  HOTLIST_MODAL_INVALID_PHONE_NUMBER_FORMAT: 'French',

  HOTLIST_MODAL_COMMENT_GUIDANCE: 'French',

  HOTLIST_MODAL_FAILED_TO_LOAD_RESORTS: 'French',

  HOTLIST_MODAL_RESORT_PLACEHOLDER: 'French',

  HOTLIST_MODAL_FROM_LABEL: 'French',

  HOTLIST_MODAL_STARTING_DATE_PLACEHOLDER: 'French',

  HOTLIST_MODAL_STARTING_DATE_TOOLTIP: 'French',

  HOTLIST_MODAL_TO_LABEL: 'French',

  HOTLIST_MODAL_ENDING_DATE_PLACEHOLDER: 'French',

  HOTLIST_MODAL_ENDING_DATE_TOOLTIP: 'French',

  HOTLIST_MODAL_REASON: 'French',

  HOTLIST_MODAL_REASON_PLACEHOLDER: 'French',

  HOTLIST_MODAL_REASON_FAILED: 'French',

  HOTLIST_MODAL_HOTLIST_LABEL: 'French',

  HOTLIST_MODAL_COMMENTS_LABEL: 'French',

  HOTLIST_MODAL_CANCEL: 'French',

  HOTLIST_MODAL_CHARACTER_INFO: (minChars: number, maxChars: number) => 'French',

  HOTLIST_TABLE_HOTLIST: 'French',

  HOTLIST_TABLE_DURATION: 'French',

  HOTLIST_TABLE_COMMENT: 'French',

  HOTLIST_TABLE_REMOVE: 'French',

  HOTLIST_TABLE_UNTIL_EXPIRATION: (date: string) => 'French',

  HOTLIST_TABLE_INDEFINITE: 'French',

  HOTLIST_TABLE_GUEST_LABEL: 'French',

  HOTLIST_TABLE_NO_HOTLIST: 'French',

  HOTLIST_REMOVE_MODAL_HEADING: 'French',

  HOTLIST_REMOVE_MODAL_SUBMIT_TITLE: (guestName: string) => 'French',

  HOTLIST_REMOVE_MODAL_CANCEL_BUTTON: 'French',

  FEATURE_DISABLING_LOADING_GUEST: 'French',

  FEATURE_DISABLING_NO_PASS: 'French',

  FEATURE_DISABLING_DEFERRED: 'French',

  FEATURE_DISABLING_HOTLISTED: 'French',

  FEATURE_DISABLING_WAIVER: 'French',

  FEATURE_DISABLING_NO_FNF: 'French',

  FEATURE_DISABLING_NOT_AVAILABLE: 'French',

  FEATURE_DISABLING_GUEST_IMPORTED: 'French',

  GUEST_SNACKBAR_FAILED_PHOTO_LOAD: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_PHOTO_SET: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_HOTLIST: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_PASSES: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_LINK: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_SUBMIT_WAIVER: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_SUBMIT_REFERENCE: (guestName: string) => 'French',

  GUEST_SNACKBAR_FAILED_IMPORT: (guestName: string) => 'French',

  GUEST_SNACKBAR_SUCCESSFUL_IMPORT: (firstName: string, lastName: string) => 'French',

  GUEST_SNACKBAR_SUCCESSFUL_IMPORT_WITH_ENTITLEMENT_ERROR: (firstName: string, lastName: string, entitlementErrorCount: number) => `${firstName} ${lastName} was successfully imported.\n${entitlementErrorCount} entitlement(s) were not imported.`,

// Group Search
  GROUP_MENU_GROUP: (NumberInGroup) => 'French',

  GROUP_MENU_CLOSE_ACTIONS : 'French',

  GROUP_MENU_EXPAND_GROUP: 'French',

  GROUP_MENU_OPEN_GROUP_ACTIONS: 'French',

  GROUP_MENU_NO_GUESTS_CAN_BE_PRINTED: 'French',

  GROUP_MENU_PRINT_PASSES: 'French',

  GROUP_MENU_NO_GUESTS_ELIGIBLE_FOR_IMPORT: 'French',

  GROUP_MENU_IMPORT_ALL_HOUSEHOLD: 'French',

  GROUP_MENU_IMPORTING_GROUP: 'French',

  GROUP_MENU_PRINT_GROUP:  'French',

  GROUP_MENU_IMPORT_GROUP: 'French',

  HORIZONTAL_GUEST_DETAIL_FIRST_NAME: 'French',

  HORIZONTAL_GUEST_DETAIL_NO_FIRST_NAME: 'French',

  HORIZONTAL_GUEST_DETAIL_LAST_NAME: 'French',

  HORIZONTAL_GUEST_DETAIL_NO_LAST_NAME: 'French',

  HORIZONTAL_GUEST_DETAIL_YEARS_OLD: (Age) => 'French',

  HORIZONTAL_GUEST_DETAIL_NO_BIRTH_DATE: 'French',

  HORIZONTAL_GUEST_DETAIL_PRIMARY_EMAIL: 'French',

  HORIZONTAL_GUEST_DETAIL_NO_EMAIL: 'French',

  HORIZONTAL_GUEST_DETAIL_PHONE_NUMBER: 'French',

  HORIZONTAL_GUEST_DETAIL_NO_PHONE_NUMBER: 'French',

  GUEST_SEARCH_RESULT_UNEXPECTED_ERROR: 'French',

  GUEST_SEARCH_RESULT_HIDE_GUESTS: 'French',

  GUEST_SEARCH_RESULT_VIEW_GUESTS: 'French',

  GUEST_SEARCH_RESULTS_NO_ACCOUNTS_MATCH: 'French',

  GUEST_SEARCH_RESULTS_PLEASE_SEARCH_AGAIN: 'French',

  GUEST_SEARCH_BOX_BLACKLISTED: 'French',

  GUEST_SEARCH_MIN_LENGTH: (MinSearchLength) => 'French',

  GUEST_SEARCH_IKON_GUEST: 'French',

  GUEST_SEARCH_SEARCH: 'French',

  GUEST_SEARCH_PLACEHOLDER: 'French',

  GUEST_SEARCH_TOP_ACCOUNT_MATCH: 'French',

  GUEST_SEARCH_TOP_ACCOUNTS_MATCH: (NumberAccounts) => 'French',

  GUEST_SEARCH_SORT_BY: 'French',

  GUEST_SORT_MENU_CLOSE: 'French',

  GUEST_SORT_MENU_OPEN: 'French',

  GUEST_SORT_RELEVANCE: 'French',

  GUEST_SORT_LAST_NAME_A_Z: 'French',

  GUEST_SORT_LAST_NAME_Z_A: 'French',

  GUEST_SORT_AGE_0_100: 'French',

  GUEST_SORT_AGE_100_0: 'French',

// PassResortSelector
  PASS_RESORT_SELECTOR_NO_PASSES: 'French',

  PASS_RESORT_SELECTOR_PASSES: 'French',

  PASS_RESORT_SELECTOR_NO_RESORTS: 'French',

  PASS_RESORT_SELECTOR_RESORTS: 'French',

  // Reports Page
  REPORTS_TITLE: 'Reports /* TODO */',
  REPORTS_PAGE_INFO: 'Run reports based on Resort Tools activity. /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS: 'Guest Hydration Errors /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_MODAL_HEADER: 'Guest Hydration Errors /* TODO */',
  GET_GUEST_HYDRATION_ERRORS_ACTION_ERROR: 'Something went wrong fetching guest hydration errors /* TODO */',
  GUEST_HYDRATION_ERRORS_RETRIED: 'Retried /* TODO */',
  GUEST_HYDRATION_ERRORS_RETRY: 'Retry /* TODO */',
  GUEST_HYDRATION_ERRORS_TOOLTIP: 'Failed hydrations! Please resolve guest errors to retry. /* TODO */',
  GUEST_HYDRATION_REPORT_COPIED_MASTER_GUEST_ID: 'Master Guest ID copied to clipboard /* TODO */',
  GUEST_HYDRATION_REPORT_COPY_MASTER_GUEST_ID: 'Copy Master Guest ID to clipboard /* TODO */',
  GUEST_HYDRATION_REPORT_MGID: 'Master Guest ID /* TODO */',
  GUEST_HYDRATION_REPORT_HYDRATION_ERROR: 'Hydration Error /* TODO */',
  GUEST_HYDRATION_ERRORS_REPLAY_FAILURE: (masterGuestId: string, resortAbbrev: string) => `Unexpected error occurred retrying the guest hydration for ${masterGuestId} at ${resortAbbrev}. Please try again later. /* TODO */`,
  GUEST_HYDRATION_ERRORS_REPLAY_SUCCESS: 'Messages have been sent to the queue for processing /* TODO */',
  GET_GUEST_HYDRATION_ERRORS_COUNT_ACTION_ERROR: 'Something went wrong fetching guest hydration error count /* TODO */',
  GUEST_HYDRATION_ERRORS_GUESTS_PER_PAGE: 'Guests per page: /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_CLOSE: 'Close /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_CLOSE_TITLE: 'Close Guest Hydration Errors Report /* TODO */',
  REPORTS_GUEST_HYDRATION_ERRORS_NO_ERRORS_TOOLTIP: 'No Guest Hydration Errors found. /* TODO */',
  REPORTS_HOTLIST_REASON: 'Reason for Hotlist /* TODO */',
  REPORTS_HOTLIST_REASON_PLACEHOLDER: 'Reason... /* TODO */',
  REPORTS_HOTLIST_REASON_FAILED: 'Failed to load reasons /* TODO */',
  REPORTS_HOTLIST_FROM_LABEL: 'From /* TODO */',
  REPORTS_HOTLIST_FROM_DATE_TOOLTIP: 'Enter the From date for the hotlist report /* TODO */',
  REPORTS_HOTLIST_TO_LABEL: 'To /* TODO */',
  REPORTS_HOTLIST_TO_DATE_TOOLTIP: 'Enter the To date for the hotlist report /* TODO */',
  REPORTS_HOTLIST_NO_REASON: 'A reason is required for the hotlist report. /* TODO */',
  REPORTS_HOTLIST_INVALID_FROM_DATE: 'A valid From date is required for the hotlist report. /* TODO */',
  REPORTS_HOTLIST_INVALID_TO_DATE: 'A valid To date is required for the hotlist report. /* TODO */',
  REPORTS_HOTLIST_FROM_BEFORE_TO_DATE: 'To date must be on or after From date. /* TODO */',
  REPORTS_HOTLIST_DATE_RANGE_MAX: 'Date range too large. The maximum date range for the hotlist report is 1 year. /* TODO */',
  REPORTS_HOTLIST_ERROR_GENERATING_CSV_FILE: 'Something went wrong generating the csv file. /* TODO */',
  REPORTS_HOTLIST_ERROR_DOWNLOAD_FAILED: 'Failed to download hotlist report. /* TODO */',
  REPORTS_HOTLIST_CREATED_DATE: 'Created Date /* TODO */',
  REPORTS_HOTLIST_NARROW_SEARCH_PARAMS: 'Too much data. Please narrow your search parameters. /* TODO */',
  REPORTS_HOTLIST_ERROR_NO_DATA: 'No hotlist data found for the current search parameters. /* TODO */',
  REPORTS_HOTLIST_REQUEST_CANCELLED: 'Request was canceled. Please try again. /* TODO */',
  REPORTS_HOTLIST_INVALID_PARAMETERS: 'Invalid request parameters. /* TODO */',
  REPORTS_WEEKLY_VISTOR_DATA: 'Weekly Visitor Data /* TODO */',
  REPORTS_CLOSE: 'Close /* TODO */',
  REPORTS_WEEKLY_VISITOR_DATA_CLOSE_TITLE: 'Close Weekly Visitor Data Reports /* TODO */',
  REPORTS_WEEKLY_VISITOR_ERROR_LOADING: 'Failed to load Weekly Visitor Data Reports /* TODO */',
  REPORTS_DOWNLOADING: 'Downloading... /* TODO */',
}

export default fr_fr;
